(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return fragmentProductHeroInfo$1; }), Promise.resolve().then(function () { return fragmentBuyBar$1; }), Promise.resolve().then(function () { return fragmentProductDetailList$1; }), Promise.resolve().then(function () { return cappasity$1; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    const {
      wrappedLoader
    } = window.PoleneLibs.ElementTemplates;
    const events$2 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$2,
      parseProductForm
    } = window.PoleneLibs.Utils;
    const {
      getRefs: getRefs$1
    } = window.PoleneLibs.Refs;
    const root = window.Shopify?.routes.root;
    const selectors$2 = {
      cartCounter: '.js-cart-counter',
      variantInput: '.js-variant-input'
    };
    const added_to_cart = window.translations?.added_to_cart || 'Added to cart';
    const addToCart = lineItems => {
      const promise = fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(lineItems)
      }).catch(error => {});
      promise.then(response => {
        if (response instanceof Response && response.status >= 200 && response.status < 300) {
          response.json().then(json => dispatchEvent$2(window, events$2.CART_UPDATED, json));
        }
      }).catch(error => {});
      return promise;
    };
    const handleAddToCart = async productForm => {
      const forms = productForm.getElementsByTagName('form');
      const form = forms[0];
      const formData = new FormData(form);
      const items = parseProductForm(formData);
      const btns = form.getElementsByTagName('button');
      const inputs = form.getElementsByTagName('input');
      const submitBtn = btns[0];
      const defaultsubmitBtnState = submitBtn.dataset.state;
      let preOrderBtn = false;
      let preOrderLabel = '';
      let eContainer;
      const states = {
        success: 'success',
        loading: 'loading',
        default: 'default',
        disabled: 'disabled'
      };
      if (submitBtn.dataset.state == states.disabled) {
        let variantId = null;
        if (!items.length) {
          variantId = form.querySelectorAll(selectors$2.variantInput)[0].value;
        } else {
          variantId = items[0].id;
          const hasOptions = form.getElementsByTagName('option');
          if (hasOptions && items[0].id === '0') {
            variantId = form.getElementsByTagName('option')[1].value;
          }
        }
        dispatchEvent$2(window, events$2.TOGGLE_BIS, {
          variantId
        });
        return;
      }
      if (productForm.nextElementSibling) {
        const {
          errorContainer
        } = getRefs$1(productForm.nextElementSibling);
        eContainer = errorContainer;
      }
      if (!submitBtn.firstElementChild) {
        preOrderBtn = true;
        preOrderLabel = submitBtn.innerHTML;
        submitBtn.innerHTML = wrappedLoader;
      }
      submitBtn.dataset.state = states.loading;
      const add = addToCart({
        items,
        sections: 'main-cart,cart-notification-product'
      });
      add.then(response => {
        if (response instanceof Response) {
          if (response.status >= 200 && response.status < 300) {
            submitBtn.dataset.state = states.success;
            if (eContainer && eContainer.innerHTML) eContainer.innerHTML = '';
            if (preOrderBtn) submitBtn.innerHTML = added_to_cart;
            setTimeout(() => {
              submitBtn.dataset.state = defaultsubmitBtnState;
              [...inputs].forEach(input => {
                input.checked = false;
              });
              if (preOrderBtn) {
                submitBtn.innerHTML = preOrderLabel;
              }
            }, 3000);
          } else {
            response.json().then(json => {
              submitBtn.dataset.state = defaultsubmitBtnState;
              if (eContainer) {
                eContainer.innerHTML = json.description;
                setTimeout(() => {
                  eContainer.innerHTML = '';
                }, 5000);
              }
            });
          }
        }
      });
    };

    const {
      breakpoints: breakpoints$1
    } = window.PoleneLibs.Breakpoints;
    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef: getElementsByRef$2
    } = window.PoleneLibs.Refs;
    let scrolledPassed = false;
    const classes$1 = {
      showBuyBar: 'buy-bar-visible',
      isPreOrder: 'is-preorder',
      titleVisible: 'title-visible'
    };
    const selectors$1 = {
      productForm: '.js-product-form'
    };
    var fragmentProductHeroInfo = async () => {
      const {
        productDetails,
        productForm,
        stickyContainer
      } = getElementsByRef$2(['product-details', 'product-form', 'sticky-container']);
      if (!productDetails || !productForm) return;
      let observer;
      let isMobile = true;
      const forms = Array.isArray(productForm) ? [...productForm] : [];
      const init = () => {
        setScreenSize();
        setEventListeners();
        observer = intersection(productDetails, handleIntersection, {
          threshold: [0]
        });
      };
      const setScreenSize = () => {
        isMobile = window.innerWidth < breakpoints$1.md;
      };
      const setEventListeners = () => {
        forms.forEach(form => form.addEventListener('submit', addToCart));
        window.addEventListener('scroll', handleScroll);
      };
      const handleScroll = () => {
        if (!isMobile || !stickyContainer) return;
        stickyContainer.classList.toggle(classes$1.titleVisible, window.scrollY > window.innerHeight * 0.7);
      };
      const addToCart = async e => {
        e.preventDefault();
        const productForm = e.target.closest(selectors$1.productForm);
        handleAddToCart(productForm);
      };
      const handleIntersection = ([entry]) => {
        if (isMobile) return;
        if (entry.isIntersecting) {
          scrolledPassed = true;
          document.body.classList.remove(classes$1.showBuyBar);
        } else {
          if (scrolledPassed) {
            document.body.classList.add(classes$1.showBuyBar);
            scrolledPassed = false;
          }
        }
      };
      setTimeout(() => {
        init();
      });
      return () => {
        observer.unobserve(productDetails);
        forms.forEach(form => form.removeEventListener('submit', addToCart));
        window.removeEventListener('scroll', handleScroll);
      };
    };

    var fragmentProductHeroInfo$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentProductHeroInfo
    });

    const events$1 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$1,
      scrollToPosition
    } = window.PoleneLibs.Utils;
    const {
      getElementsByRef: getElementsByRef$1,
      getRefs
    } = window.PoleneLibs.Refs;
    var fragmentBuyBar = () => {
      const {
        buyBar,
        addToCartBtn
      } = getElementsByRef$1(['buy-bar', 'add-to-cart-btn']);
      if (!buyBar || !addToCartBtn) return;
      const {
        toTopTrigger,
        optionsClose
      } = getRefs(buyBar);
      const init = () => {
        if (optionsClose) {
          optionsClose.addEventListener('click', handleClose);
        }
        toTopTrigger.addEventListener('click', handleClick);
      };
      const handleClick = e => {
        e.preventDefault();
        scrollToPosition(0, 1000, () => {
          if (Array.isArray(addToCartBtn)) addToCartBtn.forEach(btn => btn.focus());else addToCartBtn.focus();
        });
      };
      const handleClose = () => {
        dispatchEvent$1(window, events$1.CLOSE_OPTIONS);
      };
      init();
      return () => {
        if (optionsClose) {
          optionsClose.removeEventListener('click', handleClose);
        }
        toTopTrigger.removeEventListener('click', handleClick);
      };
    };

    var fragmentBuyBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentBuyBar
    });

    const {
      breakpoints
    } = window.PoleneLibs.Breakpoints;
    const events = window.PoleneLibs.Events.default;
    const scrollLock = window.PoleneLibs.ScrollLock.default;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef,
      getElementsByRef
    } = window.PoleneLibs.Refs;
    const selectors = {
      item: '.js-item',
      toggle: '.js-toggle',
      contentItems: '.js-content',
      threeSixty: '.js-threesixty',
      fullscreen: '.js-fullscreen',
      colorOptions: '.js-color-option'
    };
    const classes = {
      active: 'is-active',
      hidden: 'is-hidden',
      visible: 'is-visible',
      added: 'is-added',
      colorOption: 'js-color-option',
      fullscreen: 'is-fullscreen',
      isOverflow: 'is-overflow'
    };
    let currentContent = null;
    let cursorState = 'default';
    let fullscreenMode = false;
    var fragmentProductDetailList = async () => {
      const {
        cappasityTrigger
      } = getElementsByRef(['cappasity-trigger']);
      const {
        productDetails,
        productTitle,
        optionsClose,
        stickyContainer,
        backCta,
        buyBar
      } = getElementByRef(['product-details', 'product-title', 'options-close', 'sticky-container', 'back-cta', 'buy-bar']);
      if (!productDetails) return;
      const {
        toggleList,
        swapContainer,
        optionToggle
      } = getElementByRef(['toggle-list', 'swap-container', 'option-toggle', 'option-container', 'option-scroll-container', 'navigate-left', 'navigate-right'], productDetails);
      const {
        contentItems,
        toggles,
        accordionItems,
        imgView
      } = getElementsByRef(['content-items', 'toggles', 'accordion-items', 'img-view'], productDetails);
      const items = Array.isArray(contentItems) ? contentItems : [contentItems];
      const toggleItems = Array.isArray(toggles) ? toggles : [toggles];
      const accordions = Array.isArray(accordionItems) ? accordionItems : [accordionItems];
      const triggers = Array.isArray(cappasityTrigger) ? cappasityTrigger : [cappasityTrigger];
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        toggleList?.addEventListener('click', handleToggleClick);
        toggleList?.addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            handleToggleClick(event);
          }
        });
        swapContainer?.addEventListener('click', handleContainerClick);
        swapContainer?.addEventListener('mouseenter', handleMouseOver);
        swapContainer?.addEventListener('mouseleave', handleMouseLeave);
        swapContainer?.addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            handleContainerClick(event);
          }
        });
        triggers.forEach(trigger => {
          trigger?.addEventListener('click', handleTriggerClick);
          trigger?.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
              handleTriggerClick();
            }
          });
        });
        if (Array.isArray(items)) {
          items?.forEach(item => {
            item?.firstElementChild?.addEventListener('mouseenter', handleMouseLeave);
            item?.firstElementChild?.addEventListener('mouseleave', handleMouseOver);
          });
        }
        window.addEventListener(events.CLOSE_OPTIONS, closeOptions);
      };
      const setToggleAriaState = ({
        item,
        value
      }) => {
        item.setAttribute('aria-expanded', value.toString());
        item.setAttribute('aria-current', value.toString());
      };
      const handleMouseOver = () => {
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: cursorState,
          contrast: false
        });
      };
      const handleMouseLeave = () => {
        if (cursorState === 'default') return;
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
      };
      const closeOptions = () => {
        currentContent = null;
        items?.forEach(item => {
          if (item?.dataset.itemContent == 'img') {
            item?.classList.add(classes.visible);
          } else {
            item?.classList.remove(classes.visible);
          }
        });
        toggleItems?.forEach(toggle => toggle?.classList.remove(classes.active));
        if (optionToggle) {
          optionToggle.classList.remove(classes.active);
        }
        scrollLock(false);
        handleColorOptions(false);
      };
      const handleColorOptions = closeOptions => {
        if (!swapContainer) return;
        if (closeOptions) {
          productTitle?.classList.add(classes.hidden);
          optionsClose?.classList.remove(classes.hidden);
          swapContainer.style.overflowY = 'scroll';
        } else {
          productTitle?.classList.remove(classes.hidden);
          optionsClose?.classList.add(classes.hidden);
          swapContainer.style.overflowY = 'hidden';
        }
      };
      const handleTriggerClick = () => {
        const isMobile = window.innerWidth < breakpoints.md;
        if (!isMobile) return;
        handleImgView();
        if (!imgView) return;
        const views = Array.isArray(imgView) ? imgView : [imgView];
        fullscreenMode = !fullscreenMode;
        scrollLock(fullscreenMode);
        if (stickyContainer || backCta) {
          if (stickyContainer && backCta && buyBar) {
            buyBar.style.display = fullscreenMode ? 'none' : 'flex';
            backCta.style.display = fullscreenMode ? 'none' : 'flex';
            stickyContainer.style.display = fullscreenMode ? 'none' : 'flex';
          }
        }
        views.forEach(view => {
          view.classList.toggle(classes.fullscreen);
        });
      };
      const handleToggleClick = e => {
        const item = e.target.closest(selectors.item);
        const colorToggle = e.target.closest(selectors.toggle);
        const content = item ? item.dataset.item : 'options';
        if (content === currentContent) {
          if (item) {
            setToggleAriaState({
              item: item,
              value: false
            });
          }
          resetContent();
          return;
        }
        currentContent = content;
        cursorState = 'close';
        setVisibleContent(content);
        if (item) {
          let ariaBoolean = true;
          toggleItems.forEach(toggle => {
            if (toggle == item) {
              toggle?.classList.add(classes.active);
              ariaBoolean = true;
            } else {
              toggle?.classList.remove(classes.active);
              optionToggle?.classList.remove(classes.active);
              ariaBoolean = false;
            }
            if (toggle) setToggleAriaState({
              item: toggle,
              value: ariaBoolean
            });
          });
        }
        if (colorToggle) {
          toggleItems.forEach(toggle => toggle?.classList.remove(classes.active));
          optionToggle?.classList.add(classes.active);
          if (swapContainer) swapContainer.style.overflowY = 'scroll';
          scrollLock(true);
        }
      };
      const resetContent = () => {
        currentContent = null;
        cursorState = 'default';
        if (swapContainer) swapContainer.style.overflowY = 'hidden';
        scrollLock(false);
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
        setVisibleContent('img');
        toggleItems.forEach(toggle => toggle?.classList.remove(classes.active));
        if (optionToggle) {
          optionToggle.classList.remove(classes.active);
        }
      };
      const handleContainerClick = e => {
        const btn = e.target.closest(selectors.threeSixty);
        const fullscreen = e.target.closest(selectors.fullscreen);
        if (fullscreen) {
          if (!imgView) return;
          const views = Array.isArray(imgView) ? imgView : [imgView];
          const isMobile = window.innerWidth < breakpoints.md;
          fullscreenMode = !fullscreenMode;
          scrollLock(fullscreenMode);
          if (isMobile) {
            if (stickyContainer || backCta) {
              if (buyBar && backCta && stickyContainer) {
                buyBar.style.display = fullscreenMode ? 'none' : 'flex';
                backCta.style.display = fullscreenMode ? 'none' : 'flex';
                stickyContainer.style.display = fullscreenMode ? 'none' : 'flex';
              }
            }
          }
          views.forEach(view => {
            view.classList.toggle(classes.fullscreen);
          });
        }
        if (btn) {
          handleImgView();
          if (btn.classList.contains(classes.active)) {
            btn.classList.remove(classes.active);
          } else {
            btn.classList.add(classes.active);
          }
        }
        if (e.target.classList && e.target.classList.contains(classes.colorOption) || currentContent === 'img' || currentContent === null) return;
        resetContent();
      };
      const handleImgView = () => {
        if (!imgView) return;
        const views = Array.isArray(imgView) ? imgView : [imgView];
        views.forEach(view => {
          view.classList.toggle(classes.visible);
        });
      };
      const handleShowOptions = () => {
        if (productTitle && optionsClose) {
          handleColorOptions(true);
        }
        const optionContainer = items.find(item => item?.dataset.itemContent === 'options');
        optionContainer?.classList.add(classes.visible);
        scrollLock(true);
      };
      const handleToggleAccordion = content => {
        accordions?.forEach(item => {
          if (!item) return;
          if (item?.dataset.itemContent == content) {
            const height = item?.style.maxHeight == item?.scrollHeight + 'px' ? '0px' : item?.scrollHeight + 'px';
            if (height === '0px') {
              const toggle = toggleItems.find(toggle => toggle?.dataset.item === content);
              toggle?.classList.remove(classes.active);
            }
            item.style.maxHeight = height;
          } else {
            item.style.maxHeight = '0px';
          }
        });
      };
      const handleFocusOut = elementId => {
        if (!elementId) return;
        const element = document.querySelector(`[aria-controls="${elementId}"]`);
        element?.setAttribute('aria-hidden', 'true');
        element?.focus();
      };
      const setVisibleContent = content => {
        const isMobile = window.innerWidth < breakpoints.md;
        if (isMobile) {
          if (content === 'options') {
            handleShowOptions();
            scrollLock(true);
          } else {
            handleToggleAccordion(content);
          }
        } else {
          items.forEach(item => {
            const contentToFocus = item?.querySelector('.content');
            if (item?.dataset.itemContent == content) {
              item?.classList.add(classes.visible);
              contentToFocus?.setAttribute('aria-hidden', 'false');
              const childWithAriaHidden = contentToFocus?.querySelectorAll('[aria-hidden]');
              childWithAriaHidden?.forEach(child => {
                child?.setAttribute('aria-hidden', 'false');
                child.setAttribute('tabindex', '0');
              });
              contentToFocus?.addEventListener('focusout', event => {
                const eventTarget = event.relatedTarget;
                if (!eventTarget || !contentToFocus.contains(eventTarget)) {
                  childWithAriaHidden?.forEach(child => {
                    child?.setAttribute('aria-hidden', 'true');
                    child.setAttribute('tabindex', '-1');
                  });
                  handleFocusOut(contentToFocus?.getAttribute('id') || undefined);
                }
              });
              contentToFocus?.focus();
            } else {
              item?.classList.remove(classes.visible);
              contentToFocus?.removeEventListener('focusout', () => handleFocusOut);
            }
          });
        }
      };
      setTimeout(() => {
        init();
      });
      return () => {
        optionToggle?.removeEventListener('click', handleToggleClick);
        optionToggle?.removeEventListener('click', handleToggleClick);
        toggleList?.removeEventListener('click', handleToggleClick);
        toggleList?.removeEventListener('keydown', event => {
          if (event.key === 'Enter') {
            handleToggleClick(event);
          }
        });
        swapContainer?.removeEventListener('click', handleContainerClick);
        swapContainer?.removeEventListener('keydown', event => {
          if (event.key === 'Enter') {
            handleContainerClick(event);
          }
        });
        swapContainer?.removeEventListener('mouseenter', handleMouseOver);
        swapContainer?.removeEventListener('mouseleave', handleMouseLeave);
      };
    };

    var fragmentProductDetailList$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentProductDetailList
    });

    var cappasity = () => {
      const {
        getElementsByRef
      } = window.PoleneLibs.Refs;
      const {
        cappasity,
        cappasityTrigger
      } = getElementsByRef(['cappasity', 'cappasity-trigger']);
      if (!cappasity || !cappasityTrigger) return;
      const triggers = Array.isArray(cappasityTrigger) ? [...cappasityTrigger] : [cappasityTrigger];
      let isAppended = false;
      const elements = Array.isArray(cappasity) ? [...cappasity] : [cappasity];
      const AUTO_RESIZE = true;
      const REMOVE_TRIGGER_ON_ERROR = true;
      elements.map(async (element, index) => {
        try {
          const response = await fetch(`/apps/cappasity/embed-list?productId=${element.dataset.id}`);
          if (!response.ok) {
            throw '404 - Could not load Cappasity api script';
          }
          const json = await response.json();
          if (!json.length) {
            if (REMOVE_TRIGGER_ON_ERROR) {
              cappasityTrigger[index].remove();
            }
            throw '404 - Could not load 3d-view for: ' + element.dataset.id;
          }
          const playerHTML = json[0].playerHTML;
          const iframe = AUTO_RESIZE ? playerHTML.replace('height="600"', 'height="100%"').replace("height='600'", 'height="100%"').replace('hidesettingsbtn=0', 'hidesettingsbtn=1').replace('hidefullscreen=0', 'hidefullscreen=1') : playerHTML;
          triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
              if (!isAppended) {
                element.insertAdjacentHTML('afterbegin', iframe);
                isAppended = true;
              }
            });
          });
        } catch (error) {
          {
            triggers.forEach(trigger => {
              trigger.remove();
            });
          }
        }
      });
      return () => {};
    };

    var cappasity$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: cappasity
    });

})();
